































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CarteSiteCollection extends Vue {
	@Prop({ required: true })
	sitescollections!: Array<{ date: string; lien: string }>;

	@Prop({ required: true })
	periode!: string;

	get iconeLien() {
		return require('@/assets/img/icone-lien.png');
	}
}
